import styled from 'styled-components';

export const TableHeader = styled.th`
  font-weight: bold;
  font-family: 'Roboto';
  font-size: 16px;
  color: ${({ theme }) => theme.colors.header.secondaryLinkActive};
`;
